import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3, ChevronLeft, Settings } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';
import { Breadcrumb } from '@/components/ui/Breadcrumb';
import { AnalyticsDashboard } from '@/components/analytics/AnalyticsDashboard';
import { Button } from '@/components/ui/Button';

export function AnalyticsPage() {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  const isProvider = user?.role === 'provider';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Redirect non-providers
  if (!isProvider || !user) {
    setTimeout(() => navigate('/dashboard'), 0);
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 pb-20">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary-600 focus:text-white focus:rounded-lg focus:shadow-lg min-h-touch">
        Skip to main content
      </a>
      <main id="main-content" role="main" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <Breadcrumb
          items={[
            { label: 'Dashboard', href: '/dashboard' },
            { label: 'Analytics' }
          ]}
        />

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8 mt-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Analytics & Performance</h1>
            <p className="text-gray-600 mt-1">Track your business performance and growth metrics.</p>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => navigate('/dashboard')} size="sm" className="min-h-touch">Back to Dashboard</Button>
          </div>
        </div>

        {/* Content Area */}
        <div className="space-y-6">
          <div className="animate-in fade-in duration-500">
            <AnalyticsDashboard providerId={user.id} />
          </div>
        </div>
      </main>
    </div>
  );
}